const button = {
  baseStyle: {
    fontWeight: "semibold",
    borderRadius: "lg",
  },
  sizes: {
    md: { h: "40px", fontSize: "sm", px: 4 },
    sm: { h: "34px", fontSize: "sm", px: 3 },
  },
  variants: {
    // No escuro o botão principal é o Apoio com texto Noite, como no mock do Fransel.
    solid: {
      bg: "brand.500",
      color: "white",
      _hover: { bg: "brand.600", _disabled: { bg: "brand.500" } },
      _active: { bg: "brand.700" },
      _dark: {
        bg: "teal.300",
        color: "#101923",
        _hover: { bg: "teal.200", _disabled: { bg: "teal.300" } },
        _active: { bg: "teal.100" },
      },
    },
    // Apoio (#8AB6D6) não aceita texto branco (2,2:1): fundo claro da escala e texto aço.
    secondary: {
      bg: "teal.100",
      color: "brand.700",
      _hover: { bg: "teal.200" },
      _active: { bg: "teal.300" },
    },
    outline: {
      borderColor: "app-border",
      color: "app-fg",
      _hover: { bg: "app-muted" },
    },
    ghost: {
      color: "app-fg",
      _hover: { bg: "app-muted" },
    },
    onBrand: {
      bg: "white",
      color: "brand.600",
      _hover: { bg: "whiteAlpha.900" },
    },
  },
  defaultProps: {
    variant: "solid",
    size: "md",
  },
};

export default button;
